import React from 'react';

export default ({text = '', value = '', label, ...rest}) => (
	<label className='Select'>
		<div className='Select_label'>{label}</div>
		<div className='Select_value'>{text || value || '--'}</div>
		<select value={value} {...rest}/>
	</label>
);